import { YM_IDENTIFIER } from '../constants/YaMetrika';

const YmSendGoal = (goal) => {
    console.log('###goal', goal);

    if (window.ym) window.ym(YM_IDENTIFIER, 'reachGoal', goal);
};

export default YmSendGoal;
